<template>
    <div class="container">
        <div class="inner">
            <div class="title page-title">
                <h3>연혁</h3>
            </div>
            <div class="history-wrap">
                <div class="img">
                    <img src="/src/assets/images/history_bg.png" />
                </div>
                <div class="txt">
                  <dl>
                    <dt>2025년</dt>
                    <dd>
                      <p><span>08.</span> 한국디스플레이아카데미 출범식</p>
                      <p><span>06.</span> 한국디스플레이아카데미 2025 교육 프로그램 진행</p>
                    </dd>
                  </dl>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    .history-wrap {
        display: flex;
        dl {
            position: relative;
            display: flex;
            align-items: flex-start;
            justify-content: start;
            padding: 0 0 40px 78px;
            &:before {
                content: "";
                position: absolute;
                top: 0;
                left: 40px;
                width: 1px;
                height: 100%;
                background: $gray-regular_color;
            }
            &:last-child {
                padding-bottom: 0;
                &:before {
                    height: 18px;
                }
            }
            dt {
                position: relative;
                display: flex;
                margin-right: 24px;
                color: $blue_color;
                @include font-size_xl;
                font-weight: 700;
                &:before {
                    content: "";
                    position: absolute;
                    top: 50%;
                    left: -40px;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: $blue_color;
                    -webkit-transform: translateY(-50%);
                    transform: translateY(-50%);
                }
            }
            dd {
                p {
                    margin-bottom: 10px;
                    &:first-child {
                      margin-top: 4px;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    span {
                        color: $blue_color;
                        margin-right: 8px;
                        display: inline-block;
                    }
                }
            }
        }
    }
</style>
<script setup>
</script>